module.exports = "<p>Page introuvable</p>\n"